import { createSlice } from '@reduxjs/toolkit';
import { fetchClientOrderList } from './features';
import { ORDERSTATUS } from 'utils/Constants';

export const clientOrderList = createSlice({
  name: 'clientOrderList',
  initialState: {
    // Individual status arrays
    delayedOrders: [],
    inProgressOrders: [],
    nonAttributedOrders: [],
    smartOrders: [],
    smartWithReviewOrders: [],
    validatedOrders: [],

    // Computed merged array (for "Commandes en cours" tab)
    mergedInProgressOrders: [],

    // Complete list (for "Toutes les commandes" tab)
    allOrders: [],

    isLoading: true,
    isError: true,
  },
  reducers: {
    handleSorting: (state, { payload }) => {
      let array = [];

      switch (payload.table) {
        case ORDERSTATUS.VALID:
          array = [...state.validatedOrders];
          break;
        case ORDERSTATUS.DELAYED:
          array = [...state.delayedOrders];
          break;
        case ORDERSTATUS.INPROGRESS:
          array = [...state.inProgressOrders];
          break;

        case ORDERSTATUS.SMART_WITH_REVIEW:
          array = [...state.smartWithReviewOrders];
          break;
        case ORDERSTATUS.SMART:
          array = [...state.smartOrders];
          break;
        case ORDERSTATUS.ALL: // New case for "Commandes en cours" tab
          array = [...state.allOrders];
          break;
        case ORDERSTATUS.MERGED_INPROGRESS: // New case for "Toutes les commandes" tab
          array = [...state.mergedInProgressOrders];
          break;
        default:
          array = [...state.nonAttributedOrders];
          break;
      }

      if (payload.sortField) {
        const sorted = [...array].sort((a, b) => {
          if (a[payload.sortField] === null) return 1;
          if (b[payload.sortField] === null) return -1;
          if (
            payload.sortField === 'deliveredTextsAmount' ||
            payload.sortField === 'validatedTextsAmount'
          ) {
            const pourcentageA = (a[payload.sortField] * 100) / a['textAmount'];
            const pourcentageB = (b[payload.sortField] * 100) / b['textAmount'];

            return payload.sortOrder === 'asc'
              ? pourcentageA - pourcentageB
              : pourcentageB - pourcentageA;
          }

          return (
            a[payload.sortField]
              .toString()
              .localeCompare(b[payload.sortField].toString(), 'en', {
                numeric: true,
              }) * (payload.sortOrder === 'asc' ? 1 : -1)
          );
        });

        switch (payload.table) {
          case ORDERSTATUS.VALID:
            state.validatedOrders = [...sorted];
            break;
          case ORDERSTATUS.DELAYED:
            state.delayedOrders = [...sorted];
            break;
          case ORDERSTATUS.INPROGRESS:
            state.inProgressOrders = [...sorted];
            break;
          case ORDERSTATUS.SMART_WITH_REVIEW:
            state.smartWithReviewOrders = [...sorted];
            break;
          case ORDERSTATUS.SMART:
            state.smartOrders = [...sorted];
            break;
          case ORDERSTATUS.ALL:
            state.allOrders = [...sorted];
            break;
          case ORDERSTATUS.MERGED_INPROGRESS:
            state.mergedInProgressOrders = [...sorted];
            break;
          default:
            state.nonAttributedOrders = [...sorted];
            break;
        }
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchClientOrderList.fulfilled, (state, { payload }) => {
        // Preserve individual status arrays
        state.delayedOrders = payload.delayedCommands;
        state.inProgressOrders = payload.inProgressCommands;
        state.validatedOrders = payload.validatedCommands;
        state.nonAttributedOrders = payload.nonAttributedCommands.map(
          (order) => ({
            ...order,
            expanded: false,
          })
        );
        state.smartOrders = payload.smartCommands;
        state.smartWithReviewOrders = payload.smartWithReviewCommands;

        // Create merged array for "Commandes en cours" tab
        state.mergedInProgressOrders = [
          ...payload.delayedCommands,
          ...payload.inProgressCommands,
          ...payload.smartCommands,
          ...payload.smartWithReviewCommands,
        ];

        // Create complete list for "Toutes les commandes" tab
        state.allOrders = [
          ...payload.delayedCommands,
          ...payload.inProgressCommands,
          ...payload.smartCommands,
          ...payload.smartWithReviewCommands,
          ...payload.validatedCommands,
          ...payload.nonAttributedCommands,
        ];

        state.isLoading = false;
        state.isError = false;
      })
      .addCase(fetchClientOrderList.pending, (state, { payload }) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(fetchClientOrderList.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isError = true;
      });
  },
});

export default clientOrderList.reducer;
export const { handleSorting } = clientOrderList.actions;

export const clientOrderListSelector = (state) => {
  return state.clientOrderList;
};
